import {_sharedReducerShop, _sharedStateShop} from "@/shared/store/shop/reducer";

export const initialState = _sharedStateShop;

const shopReducer = (state = initialState, action) => {
  switch (action.type) {
    // Define App special cases here
    default:
      return _sharedReducerShop(state, action, initialState);
  }
};

export default shopReducer;
